const utils = require('frontend-controller/lib/utils')

module.exports = {
	extends: [
		'/',
		'base',
		'form',
		'form'
	],

	config: {
		preventRecordControllerKeyHandling: false
	},

	events: {
		/**
		 * this function handles the Escape and Enter key-down-events
		 */
		keyboard: {
			type: 'keydown',
			action: function(event){
				var self = event.data.component;
				var $target = $(event.target);
				var keyCode = utils.keyboard.getKeyCode(event);
				if($target.closest('button, textarea').length > 0 && keyCode === 'enter') {
					event.stopImmediatePropagation();
				}
				else if(self.model.recordController) {
					if(self.config.preventRecordControllerKeyHandling){
						if(keyCode === 'enter' || keyCode === 'esc'){
							// be sure that the original element looses the focus to trigger change events if necessary
							$target.blur();
						}
					} else {
						var positive = false;
						switch(keyCode){
							case 'enter':
								positive = true;
								// be sure that the original element looses the focus to trigger change events if necessary
								$target.blur();
							case 'esc':
								event.preventDefault();
								event.stopImmediatePropagation();
								if(positive){
									self.model.recordController.submit();
								}
								else {
									self.model.recordController.cancel();
								}
								break;
						}
					}
				}
			}
		}
	},

	methods: {
		onChange: function(){
			// NOTE: OVERWRITE THIS
		},

		onSubmit: function(response){
			// NOTE: OVERWRITE THIS
		}
	},

	hooks: {
		_attach: function($element, options){
			var self = this;
			if(!self.model.controller){
				self.closest('base_tabStrip_tabStrip', function(tabStrip){
					tabStrip.find('templates_artForm_entity_controller', function(controller){
						self.model.controller = controller;
					});
				});
			}
			if(!self.model.recordController){
				self.closest('templates_artForm_entity_recordController', function(recordController){
					self.model.recordController = recordController;
				});
			}

			self.parent(function(parent){
				if(parent.hasClass('base_modal_modal')){
					self.config.preventRecordControllerKeyHandling = true;
				}
			});
		}
	}
}